var filterData = [];
var searchParamsInitial = window.location.search.slice(1);
var searchParamsPrev = window.location.search.slice(1);

const collectionWrapper = document.getElementById('collection-wrapper');
var facetForm = collectionWrapper.querySelector('#FacetFiltersForm');

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function updateURL(searchParams) {
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function createSearchParams(form) {
  const formData = new FormData(form);
  return new URLSearchParams(formData).toString();
}

function renderFilters(html, event) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const facetDetailsElements = parsedHTML.querySelector('#collection-wrapper');
  document.getElementById('collection-wrapper').innerHTML = facetDetailsElements.innerHTML;
  
  facetForm = collectionWrapper.querySelector('#FacetFiltersForm');
}

function renderSectionFromFetch(url, event) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      renderFilters(html, event);
      // if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    });
}

function renderPage(searchParams, event, updateURLHash = true) {
  searchParamsPrev = searchParams;
  // const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
  // loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
  document.getElementById('product-grid-container').classList.add('loading');

  const url = `${window.location.pathname}?${searchParams}`;
  renderSectionFromFetch(url, event);

  if (updateURLHash) updateURL(searchParams);
}

function onSubmitForm(searchParams, event) {
  renderPage(searchParams, event);
}

var debouncedOnSubmit = debounce((event) => {
  // facetForm.submit();
  event.preventDefault();
  const forms = [];
  forms.push(createSearchParams(facetForm));
  onSubmitForm(forms.join('&'), event);
}, 500);

$('#collection-wrapper').on('change', '#FacetFiltersForm', debouncedOnSubmit);
$('#collection-wrapper').on('click', '.clear-filters', function(e) {
  e.preventDefault();
  renderPage('', e);
});

$('#collection-wrapper').on('click', '.mobile-filter', function() {
  facetForm.classList.toggle("open");
});
$('#collection-wrapper').on('click', '#mobile-filter-close', function() {
  facetForm.classList.remove("open");
});